/** LiveView `push_event` payloads can omit `detail`. */
function readCustomEventDetail(e: Event): unknown {
  return (e as CustomEvent<unknown>).detail;
}

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

async function waitForElement<T extends Element>(
  id: string,
  attempts = 20,
  intervalMs = 50
): Promise<T | null> {
  for (let i = 0; i < attempts; i++) {
    const el = document.getElementById(id);
    if (el) return el as unknown as T;
    await delay(intervalMs);
  }
  return null;
}

/**
 * Ask handoff: LiveView pushes after navigating from Ask intent routing
 * (`handoff_ask` query). Opens the assistant panel and prefills the composer.
 */
async function handleAssistantPrefill(detail: {
  message?: string;
  submit?: boolean;
}): Promise<void> {
  const message = detail.message;
  if (typeof message !== 'string' || !message) return;
  const submit = detail.submit === true;

  const assistantBtn = await waitForElement<HTMLElement>('assistant-btn');
  assistantBtn?.click();

  const input = await waitForElement<HTMLTextAreaElement | HTMLInputElement>(
    'assistant-message-input'
  );
  if (!input) return;

  input.value = message;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.focus();

  if (submit && !input.disabled) {
    input.closest('form')?.requestSubmit();
  }
}

export function bindAssistantHandoff(): void {
  window.addEventListener('phx:assistant_prefill', (e: Event) => {
    const raw = readCustomEventDetail(e);
    if (raw === undefined || raw === null || typeof raw !== 'object') return;
    void handleAssistantPrefill(raw as { message?: string; submit?: boolean });
  });
}
